import React from "react";
import PropTypes from "prop-types";
import Form from "../Form/form";
import {controlPropTypes} from "../formhelpers";

class Section extends React.Component {
    render() {
        const {
            descriptor
        } = this.props;
        const selector = `control-container-${descriptor.key}`;
        return (
            <fieldset>
                <div
                    id={descriptor.id}
                    className={`${selector} control-section-header`}
                    data-title={descriptor.label}
                >
                    <span
                        className="uic-sh-message-title">{descriptor.label}</span>
                    <span className="uic-sh-message-subtitle"/>
                </div>
                <Form {...this.props} />
            </fieldset>
        );
    }
}

Section.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Section.propTypes = {
    ...controlPropTypes(null, false, true),
    propsResolver: PropTypes.func.isRequired,
    onCommitChange: PropTypes.func, // not required
};

export default Section;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Layout/section.js